export const showNewSetupGuide = () =>
  window.Reqres.request('hasFeature', 'mako', 'secure_onboarding');
